export default __webpack_public_path__ + "static/media/img_ldap_response-colorBkg.923a86c4.png";